
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import LoadingView from '../../components/LoadingView/LoadingView';
import jwtDecode from 'jwt-decode';
import { TabContext, TabList } from '@mui/lab';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogTitle, FormControlLabel, FormGroup, Grid, Radio, RadioGroup, Tab, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx';
import Cancel from './../../../../assets/icons/close.png'
import checked from './../../../../assets/icons/checked.png'

const CourierDetailsDialog = (props) => {
    const [Tabvalue, setTabValue] = React.useState('1');
    const handleChange = (event: React.SyntheticEvent, newTabValue: string) => {
        setTabValue(newTabValue);
    };
    const handleClose = () => {
        props.onClose(false)
    }
    const [companyMaster, setCompanyMaster] = useState({});
    const [bike, setBike] = useState(false);
    const [motorBike, setmotorBike] = useState(false);
    const [car, setCar] = useState(false);
    const [companyDetails, setcompanyDetails] = useState({});
    const [personnels, setpersonnels] = useState({});
    const [payment, setpayment] = useState([]);
    const [tableData, setTableData] = useState([]);

    const [loading, setLoading] = useState(false);
    useEffect(() => {
        console.log(props.collection);
        console.log(props.clickedCourier);
        setCompanyMaster([]);
        setBike(false);
        setmotorBike(false);
        setmotorBike(false);
        setCar(false);
        setcompanyDetails([]);
        setpersonnels([]);
        setpayment([]);
        setTableData([]);
        props.collection.map((dt, i) => {
            console.log(dt);
            if (dt.courierCompanyDetails.id == props.clickedCourier.id) {
                console.log(dt.courierCompanyDetails);
                setCompanyMaster(dt.courierCompanyDetails);
            }
            var courierVehicle = dt.courierVehicle.filter(x => x.courierId == props.clickedCourier.id);
            var bike = courierVehicle.find(x => x.vehicleType == "Bike")
            if (bike != undefined) {
                setBike(true);
            }
            var motorbike = courierVehicle.find(x => x.vehicleType == "MotoBike")
            if (motorbike != undefined) {
                setmotorBike(true);
            }
            var car = courierVehicle.find(x => x.vehicleType == "Car")
            if (car != undefined) {
                setCar(true);
            }
            if (dt.companyDetails.courierId == props.clickedCourier.id) {
                console.log(dt.companyDetails);
                setcompanyDetails(dt.companyDetails);
            }
            if (dt.courierPersonnel.courierId == props.clickedCourier.id) {
                console.log(dt.courierPersonnel);
                setpersonnels(dt.courierPersonnel);
            }
            var payments = dt.courierPaymentDetails.filter(x => x.courierId == props.clickedCourier.id);

            if (payments != undefined && payments.length > 0) {
                console.log(payments);
                setpayment(payments)
            }


            var documents = dt.courierDocuments.filter(x => x.courierId == props.clickedCourier.id);
            var list = [];
            documents.map((data, i) => {
                var obj = {
                    Id: data.id,
                    CourierDocumentsId: data.courierId,
                    Name: data.documentName,
                    File: data.courierDocumentMapper
                }
                list.push(obj);
            })
            if (list != undefined && list.length > 0) {
                console.log(list);
                setTableData(list);
            }


        })
        setLoading(false);
    }, [])
    const dateFormated = (props) => {
        var d = new Date(props)
        return d.toDateString();
    }
    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth='lg'
                open={props.open}
                onClose={handleClose}
            >
                <Grid container>
                    <Grid item xs={6}>
                        <DialogTitle>Courier Details</DialogTitle>
                    </Grid>
                    <Grid item xs={6}>
                        <DialogActions>
                            <Button onClick={handleClose}>
                                <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                            </Button>
                        </DialogActions>
                    </Grid>
                </Grid>
                {
                    loading ? ("Loading") : (
                        <div className={`p-4`} >

                            <div className="Kyctabview">
                                <TabContext value={Tabvalue} >
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleChange} >
                                            <Tab label="Courier Registration form" value="1" />
                                            <Tab label="Documents" value="2" />

                                        </TabList>
                                    </Box>
                                </TabContext>
                            </div>
                            <div className={`${Tabvalue == '1' ? "p-3 kycform " : "d-none"} `}>

                                <div className='p-3'>

                                </div>
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={4}>
                                        <div className='d-flex' style={{ paddingTop: '1rem', gap: '10px' }}>
                                            <h5 className='headerName' style={{ fontSize: "1.5rem" }}> Delivery Vehicle Type</h5>
                                        </div>
                                    </Grid>
                                    <Grid item xs={8} sx={{ padding: '0.5rem' }}>

                                        <Checkbox checked={bike} /> Bike
                                        <Checkbox checked={motorBike} /> Motor Bike
                                        <Checkbox checked={car} /> Car
                                    </Grid>

                                </Grid>
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={4}>
                                        <div className='d-flex' style={{ paddingTop: '1rem', gap: '10px' }}>
                                            <h5 className='headerName' style={{ fontSize: "1.5rem" }}> Business type</h5>
                                        </div>
                                    </Grid>
                                    <Grid item xs={8} sx={{ padding: '0.5rem' }}>
                                        {/* <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={radiovalue}
                                onChange={handleRadioChange}
                            >
                                <FormControlLabel value="Sole" control={<Radio />} label="Sole Trader" />
                                <FormControlLabel value="Limited" control={<Radio />} label="Limited Company" />
                            </RadioGroup> */}
                                        {companyMaster != undefined ? (
                                            <>
                                                <TextField
                                                    label="Business Type"
                                                    value={companyMaster.courierBusinessType}
                                                    fullWidth
                                                    margin="normal"
                                                    InputLabelProps={{ sx: { color: '#371B17' } }}
                                                />
                                            </>

                                        ) : ""}

                                    </Grid>

                                </Grid>
                                {
                                    companyMaster.courierBusinessType != "Sole" ? (
                                        <>
                                            <Grid container sx={{ padding: '0.5rem' }}>
                                                <Grid item xs={3}>
                                                    <div className='d-flex' style={{ paddingTop: '1rem', gap: '10px' }}>
                                                        <h3 className='headerName' style={{ fontSize: "1.5rem" }}> Company Details </h3>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={9} sx={{ padding: '0.5rem' }}>

                                                </Grid>

                                            </Grid>
                                            <Grid container spacing={5} sx={{ padding: '0.5rem', paddingLeft: "10rem", paddingRight: "10rem", paddingTop: "2rem" }}>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Trade Name"
                                                        value={companyDetails.tradeName}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>

                                                    <TextField
                                                        label="Registered Country"
                                                        value={companyDetails.registeredCountry}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Registration Number"
                                                        value={companyDetails.companyRegistrationNumber}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="State"
                                                        value={companyDetails.state}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Trade Name"
                                                        value={companyDetails.tradeName}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="City"
                                                        value={companyDetails.city}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="House Number"
                                                        value={companyDetails.houseNumber}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Vat Or Tax Number"
                                                        value={companyDetails.vatOrTaxNumber}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Postal Code"
                                                        value={companyDetails.postalCode}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Incorporation Date"
                                                        value={dateFormated(companyDetails.incorporationDate)}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Billing Address"
                                                        value={companyDetails.billingAddress}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Country Code"
                                                        value={companyDetails.countryCode}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </>
                                    ) : ("")
                                }



                                <div className='d-flex  ' style={{ flexDirection: "column", marginTop: "2rem", padding: ".5rem" }}>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <h3 className='headerName' style={{ fontSize: "1.5rem" }}> Personnels Details </h3>

                                    </div>
                                    <div style={{ padding: '0.5rem', paddingLeft: "8rem", paddingRight: "8rem", paddingTop: "1rem" }}>
                                        <div className='managementCards'>

                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="First Name"
                                                        value={personnels.firstName}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Last Name"
                                                        value={personnels.lastName}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Date Of Birth"
                                                        value={dateFormated(personnels.dob)}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />

                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Home Address"
                                                        value={personnels.homeAddress}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Postal Code / Zip Code"
                                                        value={personnels.zipCode}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="City"
                                                        value={personnels.city}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Country"
                                                        value={personnels.country}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Phone Number"
                                                        value={personnels.phoneNumber}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Email Address"
                                                        value={personnels.emailAddress}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        label="Passport Or Id Number"
                                                        value={personnels.passportOrIdNumber}
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                                    />
                                                </Grid>
                                            </Grid>

                                        </div>
                                    </div>


                                </div>


                                <div className='d-flex align-items-center' style={{ gap: "10px", marginTop: "2rem" }}>
                                    <h3 className='headerName' style={{ fontSize: "1.5rem" }}>  Payment Acceptance Details  </h3>
                                </div>

                                {
                                    payment.map((dt, i) => {
                                        return (
                                            <>
                                                <div className='d-flex align-items-center' style={{ gap: "10px", marginTop: "10px" }}>
                                                    <h3 className='headerName' style={{ fontSize: "1.2rem", fontWeight: "600" }}> Settlement currency: <b>{
                                                        dt.settlementCurrencyType == 1 ? ("GBP") : ("EUR")
                                                    }</b> </h3>
                                                </div>
                                                <Grid container spacing={2} sx={{ padding: '0.5rem', paddingLeft: "10rem", paddingRight: "10rem", paddingTop: "1rem" }}>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            label="Account Holder"
                                                            value={dt.accountHolder}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ sx: { color: '#371B17' } }}
                                                        />
                                                    </Grid>
                                                    {dt.settlementCurrencyType == 2 ? (
                                                        <>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    label="Short Code"
                                                                    value={dt.shortCode}
                                                                    fullWidth
                                                                    margin="normal"
                                                                    InputLabelProps={{ sx: { color: '#371B17' } }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField
                                                                    label="Account Number"
                                                                    value={dt.accountNumber}
                                                                    fullWidth
                                                                    margin="normal"
                                                                    InputLabelProps={{ sx: { color: '#371B17' } }}
                                                                />
                                                            </Grid>
                                                        </>
                                                    ) : ("")}

                                                    {dt.settlementCurrencyType == 1 ? (
                                                        <Grid item xs={6}>
                                                            <TextField
                                                                label="Iban"
                                                                value={dt.iban}
                                                                fullWidth
                                                                margin="normal"
                                                                InputLabelProps={{ sx: { color: '#371B17' } }}
                                                            />
                                                        </Grid>
                                                    ) : ("")}

                                                </Grid>
                                            </>
                                        )

                                    })
                                }
                            </div>
                            <div className={`${Tabvalue == '2' ? "p-3" : "d-none"} `}>
                                <table className=' mt-4' style={{ width: '100%' }}>
                                    <tr>
                                        <th>Name</th>
                                        <th>Status</th>
                                        <th>Documents</th>

                                    </tr>
                                    {
                                        tableData.map((dt, i) => {
                                            return (
                                                dt.Name == "Valid driving license" || dt.Name == "Insurance documents proof " ? (
                                                    motorBike || car ? (
                                                        <tr>
                                                            <td >
                                                                <div className='d-flex' style={{ gap: "10px" }}>
                                                                    <h6> {dt.Name}*</h6>
                                                                </div>

                                                                <p className='tableDescription'>
                                                                    {dt.Description}
                                                                </p>
                                                            </td>
                                                            <td >
                                                                <div className='d-flex'>

                                                                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                                                                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                                                                </div>

                                                            </td>
                                                            <td>
                                                                <div className='pt-3'>


                                                                    {
                                                                        dt.File.map((data, i) => {
                                                                            return (
                                                                                <a href={data.documentUrl} target="_blank">{data.fileName}</a>
                                                                            )
                                                                        })
                                                                    }



                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : ("")
                                                ) : (
                                                    <tr>
                                                        <td >
                                                            <div className='d-flex' style={{ gap: "10px" }}>
                                                                <h6> {dt.Name}*</h6>
                                                            </div>

                                                            <p className='tableDescription'>
                                                                {dt.Description}
                                                            </p>
                                                        </td>
                                                        <td >
                                                            <div className='d-flex'>

                                                                <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                                                                <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                                                            </div>

                                                        </td>
                                                        <td>
                                                            <div className='pt-3'>


                                                                {
                                                                    dt.File.map((data, i) => {
                                                                        return (
                                                                            <a href={data.documentUrl} target="_blank">{data.fileName}</a>
                                                                        )
                                                                    })
                                                                }



                                                            </div>
                                                        </td>
                                                    </tr>
                                                )



                                            )
                                        })
                                    }


                                </table>
                            </div>
                        </div>
                    )
                }


            </Dialog>

        </div>
    );
};

export default CourierDetailsDialog;